<template>
    <div class="objectifsBilan d-flex" id="objectif_bilan">
        <div class="w-50 body">
            <h2 class="text-uppercase">
                <span class="span-background-red">
                    Les Objectifs
                </span>
                du bilan
            </h2>
            <div>
                <p class="mt-50 mb-50 subtitle">Le Bilan de compétences vous permet de : </p>
                <ul class="list">
                    <li> <span class="bold">Faire le point sur votre parcours professionnel</span> afin d’analyser vos
                        compétences professionnelles et personnelles, vos aptitudes et motivations.</li>
                    <li> <span class="bold">Prendre du recul </span> pour identifier un projet qui vous correspond.</li>
                    <li> <span class="bold">Valoriser votre parcours en identifiant vos points forts.</span></li>
                    <li> <span class="bold">Définir et construire un projet cohérent </span> avec vos atouts
                        professionnels et en adéquation avec votre projet de vie.</li>
                </ul>
                <p class="mt-25 mb-25">
                    Nous proposons 2 types d’accompagnement d’une durée de 18 ou 24h, en fonction de vos besoins.<br />
                    L’amplitude moyenne est de 3 mois.<br />
                    Le bilan de compétences est un accompagnement individuel au projet.<br />
                    Des recherches guidées sont nécessaires en complément des rendez-vous individuels.
                </p>
                <p>
                    Votre parcours professionnel étant unique, notre équipe de consultants vous propose un
                    accompagnement personnalisé.
                </p>
                <div>
                    <a class="btn-transparent ft-btn" href="/equipe-bilan-competences">Découvrir notre équipe bilan de
                        compétences<i class="fa-solid fa-arrow-right"></i></a>
                </div>
            </div>
        </div>
        <div class="w-50 ms-5">
            <nuxt-img src="/images/pages/bilan-competences/objectif_bilan.jpeg"></nuxt-img>
        </div>
    </div>
</template>
<script setup>

</script>
<style scoped>
.objectifsBilan .body {
    padding: 100px 0 100px 130px;
}

.objectifsBilan h2 {
    font-family: Nunito;
    font-size: 50px;
    font-style: normal;
    font-weight: 600;
    line-height: 111.5%;
    /* 61.325px */
    letter-spacing: -0.825px;
    text-transform: uppercase;
}

.subtitle {
    font-family: Inter;
    font-size: 21px;
    font-style: normal;
    font-weight: 600;
    line-height: 133%;
    /* 27.93px */
    letter-spacing: 0.84px;
    text-decoration-line: underline;
}

.objectifsBilan ul {
    margin: 0;
    padding: 0 2rem 0 2rem;
    list-style-type: disc;
}

.objectifsBilan ul li .bold {
    color: var(--accent, #25233E);

    /* txt-bold */
    font-family: Inter;
    font-size: 21px;
    font-style: normal;
    font-weight: 600;
    line-height: 144%;
    /* 25.92px */
    letter-spacing: 0.72px;
}

.objectifsBilan ul li {
    color: var(--accent, #25233E);

    /* txt */
    font-family: Inter;
    font-size: 21px;
    font-style: normal;
    font-weight: 400;
    line-height: 144%;
    letter-spacing: 0.72px;
}

.objectifsBilan p {
    font-family: Inter;
    font-size: 21px;
    font-style: normal;
    font-weight: 600;
    line-height: 138%;
    /* 28.98px */
    letter-spacing: 0.84px;
}

.bold {
    font-weight: 600;
}

img {
    height: 100%;
    object-fit: cover;
}

.objectifsBilan .btn-transparent {
    font-size: 20px;
}

.ft-btn {
    color: var(--accent, #25233E);
    text-align: center;

    /* button-xl */
    font-family: Inter;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 135%;
    /* 27px */
    letter-spacing: 0.8px;
}

@media only screen and (min-width: 300px) and (max-width: 768px) {
    .w-50 {
        width: 100% !important;
    }

    .w-50.ms-5 {
        display: none;
    }

    .objectifsBilan .body {
        padding: 30px 15px 30px 15px;
    }

    h2.text-uppercase {
        margin-left: 0px !important;
    }

    .objectifsBilan ul li,
    .objectifsBilan ul li .bold {
        font-size: 14px;
    }
}

/* Pour les appareils entre 768px et 991px de large (tablettes en mode paysage) */
@media only screen and (min-width: 769px) and (max-width: 991px) {}

/* Pour les appareils entre 992px et 1199px de large (tablettes en mode portrait et ordinateurs portables) */
@media only screen and (min-width: 992px) and (max-width: 1199px) {}

/* Pour les appareils de 1200px de large et plus (ordinateurs de bureau) */
@media only screen and (min-width: 1200px) {}
</style>